/* eslint-disable no-useless-concat */
/* eslint-disable max-statements */
/* eslint-disable max-lines-per-function */
/* eslint-disable sort-keys */
/* eslint-disable complexity */
/* eslint-disable no-magic-numbers */

'use strict';
const initPDPGallery = () => {
  const button = document.querySelector('.js-product__load-images');

  const galleries = document.querySelectorAll('.product-gallery__media-list.grid_slider');

  if (galleries) {
    galleries.forEach((galleryGrid) => {
      const galleryMedia = galleryGrid.querySelectorAll('.product-gallery__media:not([hidden])');
      const itemGridSlider = galleryGrid.classList.contains('grid_slider');
      const mediaSliceIndex = itemGridSlider ? 3 : 4;

      galleryMedia.forEach((item, index) => {
        item.style.display = 'block';
        if (index > mediaSliceIndex) {
          item.style.display = 'none';
        }
      });
    });
  }

  if (button && galleries.length > 0) {
    button.addEventListener('click', () => {
      galleries.forEach((gallery) => {
        gallery.classList.toggle('active');
      });

      if (galleries[0].classList.contains('active')) {
        button.textContent = 'Show Less Images';
      } else {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        button.textContent = 'Show More Images';
      }
    });
  }

  const arrowCarousel = document.querySelector('.product-gallery__ar-wrapper .product-gallery__btn');

  if (window.innerWidth < 999 && button && arrowCarousel) {
    button.textContent === 'Show More Images' && button.click();

    button.remove();
  }
};

function hideFirstGalleryImage() {
  const gallery = document.querySelector('.product-gallery__media-list.grid_slider');
  const firstImage = gallery.querySelector('.product-gallery__media:not([hidden])');
  if (gallery && firstImage && window.innerWidth > 900) {
    firstImage.setAttribute('hidden', '');
  }
}

const resetPDPGallery = () => {
  const button = document.querySelector('.js-product__load-images');
  const newButton = button?.cloneNode(true);

  if (button && newButton) {
    button.parentNode.replaceChild(newButton, button);
  }
};

function refreshPDPGallery() {
  const galleries = document.querySelectorAll('.product-gallery__media-list.grid_slider');
  if (galleries) {
    galleries.forEach((galleryGrid) => {
      const galleryMedia = galleryGrid.querySelectorAll('.product-gallery__media');
      const itemGridSlider = galleryGrid.classList.contains('grid_slider');
      const mediaSliceIndex = itemGridSlider ? 3 : 4;

      const colorSwatchers = document.querySelectorAll('.variant-picker__option-values .color-swatch');
      let selectedColor = '';
      colorSwatchers.forEach((swatcher) => {
        if (swatcher.hasAttribute('data-color-selected')) {
          selectedColor = `#COLOUR_${swatcher.getAttribute('data-color-name').toUpperCase()}`;
        }
      });

      let firstImg = 0;

      galleryMedia.forEach((item, counter = 0) => {
        item.style.display = 'block';
        item.removeAttribute('hidden');
        if (
          item.querySelector('img').getAttribute('alt').toUpperCase() !== selectedColor &&
          item.querySelector('img').getAttribute('alt') !== document.querySelector('.product-info__title').innerText
        ) {
          item.style.display = 'none';
          item.setAttribute('hidden', '');
        } else {
          // if(firstImg === 0) {
          //     item.setAttribute("hidden", "");
          //     firstImg++;
          // }
          counter++;
        }
      });
    });
  }
}

function thumbSliderHandler(thumbSlider) {
  const thumbSlides = thumbSlider.querySelectorAll('swiper-slide');

  thumbSlides.forEach((slide) => {
    slide.addEventListener('click', () => {
      const mainSlider = document.querySelector('.swiper-container-big-gallery');
      const slideLabel = slide.getAttribute('aria-label');
      const slidesArrActive = mainSlider.querySelectorAll('swiper-slide:not(.hidden)');
      let index = 0;
      slidesArrActive.forEach((slideActive) => {
        if (slideLabel === slideActive.getAttribute('aria-label')) {
          index = Array.from(slidesArrActive).indexOf(slideActive);
        }
      });
      if (mainSlider?.swiper) {
        mainSlider.swiper.slideTo(index);
      }
    });
  });
}

function refreshMainSlider() {
  const mainSlider = document.querySelector('.swiper-container-big-gallery');
  const thumbSlider = document.querySelector('swiper-container.swiper-thumb');
  const mainSlides = mainSlider.querySelectorAll('swiper-slide');
  const thumbSlides = thumbSlider.querySelectorAll('swiper-slide');
  const colorSwatchers = document.querySelectorAll('.variant-picker__option-values .color-swatch');
  let selectedColor = '';
  colorSwatchers.forEach((swatcher) => {
    if (swatcher.hasAttribute('data-color-selected')) {
      selectedColor = '#COLOUR_' + swatcher.getAttribute('data-color-name').toUpperCase();
      mainSlider.swiper.update();
      mainSlider.swiper.slideTo(0);
    }
  });

  const numSwatchers = document.querySelectorAll('.block-swatch');
  let selectedNum = '';
  numSwatchers.forEach((swatcher) => {
    if (document.getElementById(swatcher.htmlFor).checked) {
      if (swatcher.querySelector('span').innerText.toUpperCase() === "'-") {
        selectedNum = '#NUMBER_' + '-';
      } else {
        selectedNum = `#NUMBER_${swatcher.querySelector('span').innerText.toUpperCase()}`;
      }
    }
  });

  mainSlides.forEach((slide) => {
    slide.classList.remove('hidden');
    slide.querySelector('.product-gallery__media').removeAttribute('hidden');
    if (colorSwatchers.length > 1) {
      if (
        slide.querySelector('img').getAttribute('alt').toUpperCase() !== selectedColor &&
        slide.querySelector('img').getAttribute('alt') !== document.querySelector('.product-info__title').innerText
      ) {
        slide.classList.add('hidden');
        slide.querySelector('.product-gallery__media').setAttribute('hidden', '');
      }
    } else if (
      slide.querySelector('img').getAttribute('alt').toUpperCase().includes('#NUMBER_') &&
      slide.querySelector('img').getAttribute('alt').toUpperCase() !== selectedNum
    ) {
      slide.classList.add('hidden');
      slide.querySelector('.product-gallery__media').setAttribute('hidden', '');
    }
  });
  if (mainSlider && mainSlider.swiper) {
    mainSlider.swiper.update();
  }
  thumbSlides.forEach((slide) => {
    slide.classList.remove('hidden');
    if (colorSwatchers.length > 1) {
      if (
        slide.querySelector('img').getAttribute('alt').toUpperCase() !== selectedColor &&
        slide.querySelector('img').getAttribute('alt') !== document.querySelector('.product-info__title').innerText
      ) {
        slide.classList.add('hidden');
        slide.querySelector('.product-gallery__media').setAttribute('hidden', '');
      }
    } else if (
      slide.querySelector('img').getAttribute('alt').toUpperCase().includes('#NUMBER_') &&
      slide.querySelector('img').getAttribute('alt').toUpperCase() !== selectedNum
    ) {
      slide.classList.add('hidden');
      slide.querySelector('.product-gallery__media').setAttribute('hidden', '');
    }
  });
  if (thumbSlider && thumbSlider.swiper) {
    thumbSlider.swiper.update();
  }
}

const findMaxWidthForSliderItem = (slides) => {
  let maxWidth = 0;

  slides.forEach((slide) => {
    const width = slide.offsetWidth;

    if (width > maxWidth) {
      maxWidth = width;
    }
  });

  return maxWidth;
};

const applyMaxWidthForSliderItem = (slides, maxWidthForSliderItem) => {
  slides.forEach((slide) => {
    slide.style.width = `${maxWidthForSliderItem}px`;
  });
};

const getCountForVisibleSliderItems = () =>
  document.querySelectorAll('.component-slider-swiper-main swiper-slide:not(.hidden)').length;

const toggleSliderNav = () => {
  const count = getCountForVisibleSliderItems();
  const slider = document.querySelector('.component-slider-swiper-main');
  const navs = slider.querySelectorAll('.custom-prev-button, .custom-next-button');

  if (count <= 1) {
    navs.forEach((navEl) => {
      navEl.style.display = 'none';
    });
  } else {
    navs.forEach((navEl) => {
      navEl.style.display = 'flex';
    });
  }
};

document.addEventListener('DOMContentLoaded', () => {
  initPDPGallery();
  // hideFirstGalleryImage();

  const slides = document.querySelectorAll('.component-slider-swiper-main swiper-slide');

  const maxWidthForSliderItem = findMaxWidthForSliderItem(slides);
  applyMaxWidthForSliderItem(slides, maxWidthForSliderItem);
  toggleSliderNav();

  document.addEventListener('variant:change', () => {
    resetPDPGallery();
    initPDPGallery();
    refreshMainSlider();
    refreshPDPGallery();
    applyMaxWidthForSliderItem(slides, maxWidthForSliderItem);
    toggleSliderNav();
    hideFirstGalleryImage();
  });

  document.addEventListener('stitching:change', () => {
    resetPDPGallery();
    initPDPGallery();
    applyMaxWidthForSliderItem(slides, maxWidthForSliderItem);
    toggleSliderNav();
    // hideFirstGalleryImage();
  });

  const thumbSliderInit = document.querySelector('swiper-container.swiper-thumb');

  const shadowHost = document.querySelector('swiper-container.swiper-thumb');
  const { shadowRoot } = shadowHost;

  if (shadowRoot) {
    shadowRoot.querySelector('.swiper-button-next').style.display = 'none';
    shadowRoot.querySelector('.swiper-button-prev').style.display = 'none';
  }

  if (thumbSliderInit) {
    thumbSliderHandler(thumbSliderInit);
  }
});
